import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Text, Platform, Linking } from "react-native";

import { Modal, Button } from "components";
import { APP_UPDATE_URL } from "apis";

import { checkVersion } from "state/modules/app";

import { styles } from "./styles";

class BaseUpdateModal extends Component {
  componentDidMount = () => {
    this.props.checkVersion();
  };

  onPress = () => {
    const link = APP_UPDATE_URL(Platform.OS);
    Linking.openURL(link);
  };

  render = () => (
    <Modal visible={this.props.shouldUpdate}>
      <View style={styles.modal}>
        <Text style={styles.text}>
          This app version is not supported anymore. Please update your app by
          clicking on update
        </Text>
        <Button color="black" onPress={this.onPress} text="Update" />
      </View>
    </Modal>
  );
}

const mapDispatchToProps = {
  checkVersion,
};

const mapStateToProps = state => {
  return { shouldUpdate: state.app.shouldUpdate };
};

export const UpdateModal = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseUpdateModal);
